import { isEmpty, isNil } from 'lodash'

// The outcomes a provider's replaceEntry sequencer reports back to the table.
// PATCH_FAILED: nothing changed server-side (retry from the confirmation).
// REMOVE_FAILED: the new entry saved but the old one's removal failed — the
// server holds both. DONE: old identity removed, new entry appended.
export const REPLACE_DONE = 'done'
export const REPLACE_PATCH_FAILED = 'patchFailed'
export const REPLACE_REMOVE_FAILED = 'removeFailed'

// Shared aggregation policy for the merged content table: one allowlist entry
// answers for the sync rows its provider's `syncRowsFor` attributes to it, and
// these fold that coverage into the row's three read-only cells.

// Sum of the recorded document counts; null when nothing is recorded (a count
// of 0 is a real answer and must not read as "no data").
export const aggregateDocuments = (coveredRows) => {
  const counts = coveredRows.map((row) => row.document_count).filter((count) => !isNil(count))
  return isEmpty(counts) ? null : counts.reduce((total, count) => total + count, 0)
}

// The most recent sync over the coverage; null when nothing has synced yet.
// ISO-8601 timestamps compare correctly as strings.
export const aggregateLastSynced = (coveredRows) => {
  const times = coveredRows.map((row) => row.last_synced_at).filter((time) => !isNil(time))
  return isEmpty(times) ? null : times.reduce((latest, time) => (time > latest ? time : latest))
}

// Worst-case status: any covered error is THE status (it is what the operator
// must act on), a fully synced coverage is Synced, and anything else — empty
// coverage, a never-resolved selector, a row awaiting its first run — is
// Pending.
export const aggregateStatus = (coveredRows) => {
  const errorRow = coveredRows.find((row) => !isNil(row.last_error))
  if (!isNil(errorRow)) {
    return { kind: 'error', code: errorRow.last_error }
  }
  if (!isEmpty(coveredRows) && coveredRows.every((row) => !isNil(row.last_synced_at))) {
    return { kind: 'synced' }
  }
  return { kind: 'pending' }
}
